
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiClassiAssetEsperienzeDialog extends Serenity.EntityDialog<ProdottiClassiAssetEsperienzeRow, any> {
        protected getFormKey() { return ProdottiClassiAssetEsperienzeForm.formKey; }
        protected getIdProperty() { return ProdottiClassiAssetEsperienzeRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiClassiAssetEsperienzeRow.localTextPrefix; }
        protected getService() { return ProdottiClassiAssetEsperienzeService.baseUrl; }
        protected getDeletePermission() { return ProdottiClassiAssetEsperienzeRow.deletePermission; }
        protected getInsertPermission() { return ProdottiClassiAssetEsperienzeRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiClassiAssetEsperienzeRow.updatePermission; }

        protected form = new ProdottiClassiAssetEsperienzeForm(this.idPrefix);

    }
}